<div class="main-vehicle-card">
  <!-- Diálogo de Confirmación Global -->
  <p-confirmDialog />

  <!-- Cabecera del Módulo -->
  <div class="module-header d-flex justify-content-between align-items-center">
    <div>
      <h2 class="module-title">Gestión de Vehículos</h2>
      <p class="module-subtitle">Directorio de flotas y asignación de conductores administrativos</p>
    </div>
    <div>
      <p-button
        label="Nuevo Vehículo"
        severity="primary"
        icon="pi pi-plus"
        [rounded]="true"
        routerLink="create"
      />
    </div>
  </div>

  <!-- Barra de Filtros y Búsqueda -->
  <div class="table-caption-bar mt-2">
    <div class="d-flex align-items-center gap-2 flex-grow-1" style="max-width: 400px;">
      <p-iconField iconPosition="left" class="w-100">
        <p-inputIcon>
          <i class="pi pi-search"></i>
        </p-inputIcon>
        <input
          #inputFindGlobal
          pInputText
          type="text"
          class="w-100"
          (input)="dtVehicle.filterGlobal(inputFindGlobal.value, 'contains')"
          placeholder="Buscar matrícula, modelo, marca, color, año..."
        />
      </p-iconField>
    </div>
    <div class="d-flex gap-2">
      <p-button
        [rounded]="true"
        [text]="true"
        icon="pi pi-refresh"
        pTooltip="Actualizar datos"
        tooltipPosition="top"
        (onClick)="getListVehicle()"
      />
    </div>
  </div>

  <!-- Tabla de Vehículos -->
  <div class="mt-3">
    <p-table
      #dtVehicle
      [value]="ltsVehicle"
      [loading]="loading"
      [tableStyle]="{ 'min-width': '50rem' }"
      styleClass="p-datatable-striped p-datatable-sm"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[5, 10, 20]"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Vehículos"
      [globalFilterFields]="[
        'veh_plate',
        'veh_model',
        'veh_brand',
        'veh_color',
        'veh_anio'
      ]"
    >
      <ng-template pTemplate="header">
        <tr>
          <th id="tbplate">Matrícula / Placa</th>
          <th id="tbbrand">Marca</th>
          <th id="tbmodel">Modelo</th>
          <th id="tbcolor">Color</th>
          <th id="tbyear">Año</th>
          <th id="tbstatus">Estado</th>
          <th id="tbaction" style="width: 14rem;">Acciones</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-veh>
        <tr>
          <td class="font-bold text-color" style="letter-spacing: 0.5px;">{{ veh.veh_plate }}</td>
          <td>{{ veh.veh_brand }}</td>
          <td>{{ veh.veh_model }}</td>
          <td>{{ veh.veh_color }}</td>
          <td>{{ veh.veh_anio }}</td>
          <td>
            @if (veh.veh_status == 1) {
              <span class="status-badge status-active">
                <i class="pi pi-check-circle me-1"></i> Activo
              </span>
            }
            @if (veh.veh_status == 0) {
              <span class="status-badge status-deleted">
                <i class="pi pi-times-circle me-1"></i> Eliminado
              </span>
            }
          </td>
          <td>
            <div class="action-buttons-group">
              <p-button
                icon="pi pi-file-edit"
                [rounded]="true"
                [text]="true"
                severity="primary"
                pTooltip="Editar Ficha"
                tooltipPosition="top"
                (onClick)="showDialog(veh)"
              />
              <p-button
                icon="pi pi-info-circle"
                [rounded]="true"
                [text]="true"
                severity="secondary"
                pTooltip="Ver Detalles"
                tooltipPosition="top"
                [routerLink]="['detail', veh.veh_id]"
              />
              <p-button
                icon="pi pi-user-minus"
                [rounded]="true"
                [text]="true"
                severity="warning"
                pTooltip="Desasignar Conductor"
                tooltipPosition="top"
                (onClick)="UnassignVehicle($event, veh)"
              />
              <p-button
                icon="pi pi-trash"
                [rounded]="true"
                [text]="true"
                severity="danger"
                pTooltip="Eliminar de Flota"
                tooltipPosition="top"
                (onClick)="deleteVehicle($event, veh)"
              />
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- Modal para Editar Ficha de Vehículo -->
<p-dialog
  header="Editar Ficha de Vehículo"
  [modal]="true"
  [(visible)]="dialogEdit"
  [style]="{ width: '42rem' }"
  [draggable]="false"
  [resizable]="false"
  styleClass="custom-dialog"
>
  <div class="p-3">
    <p class="text-secondary small mb-4">Actualice las especificaciones técnicas e inspección del vehículo seleccionado.</p>
    
    <form (ngSubmit)="save()" [formGroup]="formVehiculo">
      <div class="row">
        <!-- Placa -->
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label-edit mb-2">Matrícula / Placa*</label>
          <input
            type="text"
            pInputText
            formControlName="veh_plate"
            class="largeInput"
            autocomplete="off"
            placeholder="Ej: ABC-1234"
          />
          <span
            class="text-danger labelError"
            *ngIf="
              formVehiculo.controls['veh_plate'].hasError('required') && 
              formVehiculo.controls['veh_plate'].touched
            "
          >
            La placa es requerida.
          </span>
        </div>

        <!-- Nro Registro -->
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label-edit mb-2">Número de Registro*</label>
          <input
            type="text"
            pInputText
            formControlName="veh_num_registration"
            class="largeInput"
            placeholder="Ingrese el número de registro"
          />
          <span
            class="text-danger labelError"
            *ngIf="
              formVehiculo.controls['veh_num_registration'].hasError('required') && 
              formVehiculo.controls['veh_num_registration'].touched
            "
          >
            El número de registro es requerido.
          </span>
          <span
            class="text-danger labelError"
            *ngIf="
              formVehiculo.controls['veh_num_registration'].hasError('pattern') && 
              formVehiculo.controls['veh_num_registration'].touched
            "
          >
            Debe ingresar únicamente números.
          </span>
        </div>
      </div>

      <div class="row">
        <!-- Marca -->
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label-edit mb-2">Marca*</label>
          <input
            type="text"
            pInputText
            formControlName="veh_brand"
            class="largeInput"
            placeholder="Ej: Toyota"
          />
          <span
            class="text-danger labelError"
            *ngIf="
              formVehiculo.controls['veh_brand'].hasError('required') && 
              formVehiculo.controls['veh_brand'].touched
            "
          >
            La marca es requerida.
          </span>
        </div>

        <!-- Modelo -->
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label-edit mb-2">Modelo*</label>
          <input
            type="text"
            pInputText
            formControlName="veh_model"
            class="largeInput"
            placeholder="Ej: Corolla"
          />
          <span
            class="text-danger labelError"
            *ngIf="
              formVehiculo.controls['veh_model'].hasError('required') && 
              formVehiculo.controls['veh_model'].touched
            "
          >
            El modelo es requerido.
          </span>
        </div>
      </div>

      <div class="row">
        <!-- Año -->
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label-edit mb-2">Año de Fabricación*</label>
          <input
            type="text"
            pInputText
            formControlName="veh_anio"
            class="largeInput"
            placeholder="Ej: 2023"
          />
          <span
            class="text-danger labelError"
            *ngIf="
              formVehiculo.controls['veh_anio'].hasError('required') && 
              formVehiculo.controls['veh_anio'].touched
            "
          >
            El año es requerido.
          </span>
          <span
            class="text-danger labelError"
            *ngIf="
              formVehiculo.controls['veh_anio'].hasError('pattern') && 
              formVehiculo.controls['veh_anio'].touched
            "
          >
            Debe ingresar un año válido (números).
          </span>
        </div>

        <!-- Color -->
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label-edit mb-2">Color*</label>
          <input
            type="text"
            pInputText
            formControlName="veh_color"
            class="largeInput"
            placeholder="Ej: Amarillo"
          />
          <span
            class="text-danger labelError"
            *ngIf="
              formVehiculo.controls['veh_color'].hasError('required') && 
              formVehiculo.controls['veh_color'].touched
            "
          >
            El color es requerido.
          </span>
        </div>
      </div>

      <div class="row">
        <!-- Ocupantes -->
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label-edit mb-2">Cantidad de Pasajeros*</label>
          <input
            type="text"
            pInputText
            formControlName="veh_quantity_person"
            class="largeInput"
            placeholder="Ej: 4"
          />
          <span
            class="text-danger labelError"
            *ngIf="
              formVehiculo.controls['veh_quantity_person'].hasError('required') && 
              formVehiculo.controls['veh_quantity_person'].touched
            "
          >
            La cantidad es requerida.
          </span>
        </div>
      </div>

      <!-- Certificaciones Checkboxes -->
      <div class="detail-card p-3 my-3">
        <h4 class="form-label-edit mb-3" style="font-size: 0.95rem;"><i class="pi pi-verified me-1 text-primary"></i> Certificaciones Legales</h4>
        <div class="row">
          <div class="col-12 col-md-6 d-flex align-items-center gap-2">
            <p-checkbox formControlName="veh_inspection" [binary]="true" inputId="ins_checkbox" />
            <label for="ins_checkbox" class="form-label-edit m-0 cursor-pointer">Inspección Mecánica Aprobada</label>
          </div>
          <div class="col-12 col-md-6 d-flex align-items-center gap-2">
            <p-checkbox formControlName="veh_secure" [binary]="true" inputId="sec_checkbox" />
            <label for="sec_checkbox" class="form-label-edit m-0 cursor-pointer">Seguro Vehicular Vigente</label>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2 pt-3 border-top mt-3">
        <p-button
          label="Cancelar"
          [outlined]="true"
          severity="secondary"
          [rounded]="true"
          (onClick)="dialogEdit = false"
        />
        <p-button 
          label="Guardar Cambios" 
          severity="primary" 
          [rounded]="true"
          type="submit" 
          [disabled]="formVehiculo.invalid"
        />
      </div>
    </form>
  </div>
</p-dialog>
